// extracted by mini-css-extract-plugin
module.exports = {"pipelineDetailsRow":"review_pipelineDetailsRow__BJWm-","rowSubTitle":"review_rowSubTitle__Ca3eY","rowValues":"review_rowValues__3YtzG","actionBtns":"review_actionBtns__38cJH"};